// extracted by mini-css-extract-plugin
module.exports = {"root":"DateRange_root__1WWWL","rangePicker":"DateRange_rangePicker__2QVAX","rangePickerDropdown":"DateRange_rangePickerDropdown__1LszN"};